import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import { discounted } from '../sprinkles/discount';

type TurboFrame = HTMLElement & { reload(): unknown };

export default class CartNotificationController extends Controller {
  static values = {
    itemId: Number,
    count: Number,
    subtotal: String,
    recordId: Number,
    cartItemIds: String,
  };
  declare itemIdValue: number;
  declare countValue: number;
  declare subtotalValue: string;
  declare recordIdValue: number;
  declare cartItemIdsValue: string;

  timeout: NodeJS.Timeout | null = null;

  connect(): void {
    $(this.element).slideDown();
    $('.cart-icon').attr('data-content', this.countValue);
    $('.cart-subtotal').html(this.subtotalValue);
    this.timeout = setTimeout(() => {
      $(this.element).slideUp();
    }, 5000);
    $(`#item_id_${this.itemIdValue}`).prop('disabled', true);
    $('meta[name="cart-item-ids"]').attr('content', this.cartItemIdsValue);
    discounted();

    const frame = document.querySelector<TurboFrame>(
      `#record-content-frame-${this.recordIdValue}`
    );
    if (frame) {
      frame.reload();
    }
  }

  stopTimeout(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }
}
